import axios from "../utils/axios";
import g_axios from "axios";
import { ChartMode, CounterActive } from "../views/dashboard";
import { T_Album } from "@type/global.types";
import { Backend, Frontend } from "shared-types";
import url from "../utils/urls";
import { Dispatch } from "redux";

export async function loginAction(data: Backend.T_SignInForm) {
  const response: Frontend.T_Response<{ token: string }> = await axios.post(
    url.user.login,
    data
  );
  return response.data;
}

export async function registerAction(data: Backend.T_SignUpForm) {
  const response: Frontend.T_Response<{ user: Backend.T_User }> =
    await axios.post(url.user.new, data);
  return response;
}

export async function getUserInfo() {
  const response: Frontend.T_Response<{
    userInfo: Backend.T_UserInfo;
    totalCounter: Frontend.T_TotalCounters;
  }> = await axios.get("/getUserInfo");
  return response.data;
}

export async function setUserInfo(data: any) {
  let formData = new FormData();
  Object.keys(data).forEach((key) => {
    formData.append(key, data[key]);
  });
  const response = await axios.post("/setUserInfo", formData);
  if (response.status === 200) return response.data;
  else return [];
}

export async function isExistFile(id: any) {
  const response = await g_axios.get(
    `https://prelistening.cugate.com/?i=${id}&check=1`,
    {}
  );
  if (response.status === 200) return response.data;
  else return [];
}

export async function getMoods() {
  const response: Frontend.T_Response<{ moods: Backend.T_Mood[] }> =
    await axios.get("/getMoods", {});
  if (response.status === 200) return response.data.data.moods;
  else return [];
}

export async function getLanguages() {
  const response: Frontend.T_Response<{ languages: Backend.T_Language[] }> =
    await axios.post("/getLanguages", {});
  if (response.status === 200) return response.data.data.languages;
  else return [];
}

export async function getPublisher() {
  const response: Frontend.T_Response<any> = await axios.post(
    "/getPublisher",
    {}
  );
  if (response.status === 200) return response.data.data.publisher;
  else return [];
}

export async function getCopyRightP() {
  const response: Frontend.T_Response<any> = await axios.get(
    "/get-copyrightp",
    {}
  );
  if (response.status === 200) return response.data.data.copyright_p;
  else return [];
}

export async function getTempos() {
  const response: Frontend.T_Response<{ result: Backend.T_Tempo[] }> =
    await axios.get("/getTempos", {});
  if (response.status === 200) return response.data.data.result;
  else return [];
}

export async function getRoles() {
  const response: Frontend.T_Response<{ roles: Backend.T_MemberRole[] }> =
    await axios.post("/getRoles", {});
  if (response.status === 200) return response.data.data.roles;
  else return [];
}

export async function getPricingTier() {
  const response: Frontend.T_Response<{ roles: Backend.T_MemberRole[] }> =
    await axios.post("/getPricingTier", {});
  if (response.status === 200) return response.data.data.roles;
  else return [];
}

export async function getTrackPricingTier() {
  const response: Frontend.T_Response<{ result: Backend.T_MemberPricingTier[] }> =
    await axios.post("/getTrackPricingTier", {});
  if (response.status === 200) return response.data.data.result;
  else return [];
}

export async function getArtists(keyword?: string) {
  const response = await axios.get("/getArtists", {
    params: {
      keyword: keyword,
      limit: 15,
    },
  });
  if (response.status === 200) return response.data;
  else return [];
}

export async function getComposers(keyword: string) {
  const response = await axios.get("/getComposers", {
    params: {
      keyword: keyword,
      limit: 15,
    },
  });
  if (response.status === 200) return response.data;
  else return [];
}

export async function getFilterStations() {
  const response = await axios.post("/getFilterStations", {});
  if (response.status === 200) return response.data;
  else return [];
}

export async function getTopRankTracks(params: any) {
  const response = await axios.post("/getTopRankTracks", params);
  if (response.status === 200) return response.data;
  else return [];
}

export async function getTopRankAlbums(params: any) {
  const response = await axios.post("/getTopRankAlbums", params);
  if (response.status === 200) return response.data;
  else return [];
}

export async function getLatestAlbums(params: { limit: number }): Promise<{
  list: T_Album[];
  listType: "" | "user-album-list" | "cugate-album-list" | "company-album-list";
}> {
  const response = await axios.get("/album/latest", {
    params: params,
  });
  if (response.status === 200) return response.data;
  else return { list: [], listType: "user-album-list" };
}

export async function getTopReportData(params: {
  type_date: ChartMode;
  type_data: CounterActive;
}) {
  const response: Frontend.T_Response<{
    list: Backend.T_BelieveStatistics1[];
  }> = await axios.post("/getTopReportData", params);
  return response.data;
}

export async function getTotalLabels(params: any) {
  const response = await axios.get("/getTotalLabels", { params });
  if (response.status === 200) return response.data;
  else return [];
}

export async function capturePaypalPayment(params: {
  orderID: any;
  token: any;
  plan: any;
  months: string;
  client: any;
  ip: string;
}) {
  const response = await axios.post("/capturePaypalPayment", params);
  if (response.status === 200) return response.data;
  else return [];
}

export async function getTopRankMembers(params: any) {
  const response = await axios.post("/getTopRankMembers", params);
  if (response.status === 200) return response.data;
  else return [];
}

export async function getChartData(params: any) {
  const response = await axios.post("/getChartData", params);
  if (response.status === 200) return response.data;
  else return [];
}

export async function getReleaseChartData(params: any) {
  const response = await axios.post("/getReleaseChartData", params);
  if (response.status === 200) return response.data;
  else return [];
}

export async function getSearchTrackList(params: {
  pagination: any;
  filter: any;
}) {
  const response = await axios.get("/getSearchTrackList", {
    params: params,
  });
  if (response.status === 200) return response.data;
  else return [];
}

export async function getTrackInfo(track_id: string | number) {
  let response: Frontend.T_Response<{ info: Frontend.T_TrackMetadataOutput }> =
    await axios.get(`/track/info/${track_id}`);
  return response.data.data.info;
}

export async function saveLabel(params: any) {
  const response = await axios.post("/saveLabel", params);
  if (response.status === 200) return response.data;
  else return [];
}

export async function savePublisher(params: any) {
  const response = await axios.post("/savepublisher", params);
  if (response.status === 200) return response.data;
  else return [];
}

export async function saveCopyrightP(params: any) {
  const response = await axios.post("/savecopyrightP", params);
  if (response.status === 200) return response.data;
  else return [];
}

export async function saveLicensor(params: any) {
  const response = await axios.post("/saveLicensor", params);
  if (response.status === 200) return response.data;
  else return [];
}

export async function saveMember(
  params: { [x: string]: string | Blob },
  onProgress = (e: any) => { }
) {
  let formData = new FormData();
  Object.keys(params).forEach((key) => {
    if (key !== "avatar") formData.append(key, params[key]);
  });
  const response = await axios.post("/saveMember", formData, {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      "Access-Control-Allow-Origin": "*",
    },
  });
  if (response.status === 200) return response.data;
  else return [];
}

export async function saveAlbum(params: any) {
  const response = await axios.post("/saveAlbum", params);
  if (response.status === 200) return response.data;
  else return [];
}

export async function getMemberTypeList(params: any) {
  const response = await axios.get("/getMemberTypeList", { params });
  if (response.status === 200) return response.data;
  else return [];
}

export async function getGenderList(params: any) {
  const response = await axios.get("/getGenderList", { params });
  if (response.status === 200) return response.data;
  else return [];
}

export async function getClientList(params: any) {
  const response = await axios.post("/getClientList", params);
  if (response.status === 200) return response.data;
  else return [];
}

export async function getSearchTrackList_challenge(params: any) {
  const response = await axios.post("/getSearchTrackList_challenge", params);
  if (response.status === 200) return response.data;
  else return [];
}

export async function getIpAddress() {
  const res = await g_axios.get("https://geolocation-db.com/json/");
  return res.data?.IPv4;
}

export async function getSearchTrackTitleList(params: { keyword: string }) {
  const response = await axios.get("/getSearchTrackTitleList", { params });
  if (response.status === 200) return response.data;
  return [];
}

export async function getSearchAlbumList(params: any) {
  const response = await axios.post("/getSearchAlbumList", params);
  if (response.status === 200) return response.data;
  else return [];
}

export async function getSearchLabelList(params: any) {
  const response = await axios.post("/getSearchLabelList", params);
  if (response.status === 200) return response.data;
  else return [];
}

export async function getSearchArtistList(params: any) {
  const response = await axios.post("/getSearchArtistList", params);
  if (response.status === 200) return response.data;
  else return [];
}

export async function getSearchStationList(params: any) {
  const response = await axios.post("/getSearchStationList", params);
  if (response.status === 200) return response.data;
  else return [];
}

export const getTotalCounters = async (): Promise<Frontend.T_TotalCounters> => {
  const response = await axios.get("/getTotalCounters");
  return response.data.result;
};

export async function uploadTrackToAnalyzeByCutrackNet(
  file: string | Blob,
  onProgress = (e: any) => { }
) {
  let formData = new FormData();
  formData.append("audio_file", file);
  formData.append("start_time", "0");
  formData.append("check_wm", "True");
  formData.append("check_fp", "True");
  formData.append("check_id3", "True");
  formData.append("vid_length", "60");
  const response = await g_axios.post(
    //"/uploadTrackToAnalyzeByCutrackNet",
    "https://extension.cutrack.net/analyze_file/",
    formData,
    {
      headers: {},
      onUploadProgress: onProgress,
    }
  );
  if (response.status === 200) return response.data;
}

export async function uploadAnalyzeFile(
  file: string | Blob,
  onProgress = (e: any) => { }
) {
  let formData = new FormData();
  formData.append("audio_file", file);
  const response = await axios.post("/uploadAnalyzeFile", formData, {
    headers: {},
    onUploadProgress: onProgress,
  });
  if (response.status === 200) return response.data;
  else return response.statusText;
}

export async function deleteAnalyzeFile(id: number) {
  try {
    const response: Frontend.T_Response<{}> = await axios.delete(
      url.upload.delete(id)
    );
    if (response.data.status) return true;
    else return false;
  } catch (error) {
    return false;
  }
}

export async function urlTrackToAnalyzeByCutrackNet(url = "", id = -1) {
  const response = await axios.get("/cutracknet/analyze/url", {
    params: {
      url,
      id,
      start_time: 0,
      check_wm: "True",
      check_fp: "True",
      check_id3: "True",
      vid_length: 60,
    },
  });
  if (response.status === 200) return response.data;
  else throw new Error("track analyze error");
}

export async function uploadTrackToAnalyze(
  file: string | Blob,
  onProgress = (e: any) => { }
) {
  let formData = new FormData();
  formData.append("musicFile", file);
  const response = await axios.post("/uploadTrackToAnalyze", formData, {
    headers: {},
    onUploadProgress: onProgress,
  });
  if (response.status === 200) return response.data;
}

export async function getAnalyzeTrackInfo(data: { filename: string | Blob }) {
  let formData = new FormData();
  formData.append("filename", data.filename);
  const response = await axios.post("/getAnalyzeTrackInfoJson", formData, {
    headers: {},
  });
  if (response.status === 200) return response.data;
}

export async function getGeoInfo(lat: any, long: any) {
  let data = {
    lat: lat,
    lng: long,
    username: "goldstar22501",
  };
  const response = await g_axios.get("http://api.geonames.org/countryCode", {
    data,
  });
  if (response.status === 200) return response.data;
  else return [];
}

export async function getSubGenre(genre: any) {
  const response = await axios.get("/getSubGenre");
  if (response.status === 200) return response.data;
  return [];
}

export async function getPerformerList(keyword: any) {
  const response = await axios.get("/getPerformerListByKeyword");
  if (response.status === 200) return response.data;
  return [];
}

export async function createTrack(trackData: Frontend.T_TrackMetadataOutput) {
  const response: Frontend.T_Response<{
    result: Backend.T_TrackRegisterUpdateStatus;
  }> = await axios.post("/track/new", trackData);
  return response.data;
}

export async function updateTrack(
  track_id: number,
  trackData: Frontend.T_TrackMetadataOutput
) {
  const response: Frontend.T_Response<{
    result: Backend.T_TrackRegisterUpdateStatus;
  }> = await axios.put(`/track/${track_id}`, trackData);
  return response.data;
}

export async function getCountryList(data: any) {
  const response = await axios.post("/getCountryList", data, {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      "Access-Control-Allow-Origin": "*",
    },
  });
  if (response.status === 200) return response.data;
  return [];
}

export async function getReleaseTrack(id: number, dispatch: Dispatch) {
  const response = await axios.get("/get-release-track", {
    params: {
      id,
    },
  });
  if (response.status === 200) {
    const releaseInfo = response.data.result[0];
    dispatch({ type: "SET_EDIT_RELEASE_TRACK", payload: releaseInfo });
    return releaseInfo;
  } else {
    return [];
  }
}

export async function resendVerifyEmail(email: string) {
  const response: Frontend.T_Response<{}> = await axios.post(
    url.user.resendVerifyEmail,
    {
      email,
    }
  );
  return response.data;
}

export async function resetPassword(
  email: string,
  username: string,
  newPassword: string
): Promise<void> {
  try {
    const response = await axios.post<void>(url.user.resetPassword, {
      email,
      username,
      newPassword,
    });

    return response.data;
  } catch (error) {
    throw error;
  }
}
